module.exports = __webpack_public_path__ + "static/media/aland-islands.08163d37.svg";